import { Center, Image, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { signDocUrl_ } from "hooks/datahook/common";

const PREFIX = "d3p3b0rs4lnh2l.cloudfront.net";

const AutoFetchImage = (props) => {
    const {
        initialUrl = '',
        boxSize = null,
        rounded = null,
        ...other
    } = props;
    const [uri, setUri] = useState("");
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false); // ⭐ 控制图片是否真正 load 完成

    const isValidPrefix = (url) => {
        try {
            return url.includes(PREFIX);
        } catch {
            return false;
        }
    };

    const fetchNewImageUrl = async (badUrl) => {
        try {
            const res = await signDocUrl_({ url: badUrl });
            return res.signedUrl;
        } catch (e) {
            console.error("fetchNewImageUrl error:", e);
            return "";
        }
    };

    useEffect(() => {
        const processUrl = async () => {
            setLoading(true);
            setLoaded(false); // ⭐ 每次换图先设为未加载

            if (!isValidPrefix(initialUrl)) {
                setUri(initialUrl);
                return;
            }

            const newUrl = await fetchNewImageUrl(initialUrl);
            setUri(newUrl);
        };

        processUrl();
    }, [initialUrl]);

    // ⭐ 图片加载成功后才显示 image
    const handleLoad = () => {
        setLoaded(true);
        setLoading(false);
    };

    const handleError = () => {
        console.warn("Image load failed:", uri);
        // 图片失败时，保持不显示 image
        setLoaded(false);
        setLoading(false);
    };

    return (
        <Center
            cursor="pointer"
            position="relative"
            {...(boxSize && { w: boxSize, h: boxSize })}
        >
            {/* ⭐ loaded === true 才显示图片，否则完全不渲染，避免出现破损 icon */}
            {loaded && (
                <Image
                    src={uri}
                    rounded={rounded}
                    onLoad={handleLoad}
                    onError={handleError}
                    boxSize={boxSize}
                    {...other}
                />
            )}

            {/* ⭐ 强制预加载，用于触发 onLoad / onError，但不显示出来 */}
            <Image
                src={uri}
                rounded={rounded}
                onLoad={handleLoad}
                onError={handleError}
                display="none"
                boxSize={boxSize}
                {...other}
            />

            {loading && (
                <Center
                    zIndex={2}
                    position="absolute"
                    rounded={rounded}
                    top={0}
                    bottom={0}
                    left={0}
                    right={0}
                    bg="rgba(0,0,0,0.3)"
                >
                    <Spinner size="md" />
                </Center>
            )}
        </Center>
    );
};

export default AutoFetchImage;
